<template>
 <div class="row" style="margin-top:50px;">
  <div class="col-md-6">
    <SVGMolde :modelo="modelo" estilo="fill:orange" style="max-width:300px" />
    <SVGMolde class="svgmodelo" :modelo="molde" estilo="fill:rgba(66, 209, 228, 0.8)" style="max-width:300px" v-if="showmolde" :class="{active : showmolde}"/>

<!-- BOTÃO MOSTRAR MOLDE -->
<button class="btn" v-on:click="showmolde =! showmolde" :class="[showmolde ? 'btn-secondary' : '']" v-html="!showmolde ? 'Mostrar Molde' : 'Ocultar Molde'"></button>
<!-- BOTÃO MOSTRAR MOLDE -->

</div>
<div class="col-md-6" v-on:keyup.enter="calcularTabela">

  <div class="input-group mb-3">
    <div class="input-group-prepend">
      <span class="input-group-text" id="basic-addon3">Torax&nbsp&nbsp&nbsp</span>
    </div>
    <input class="form-control form-control-lg" :class="[campoFormVazio && torax == '' ? 'campo_vazio' : '' ]" :value="torax" type="text" placeholder="Medidas do Torax" @input="atualizar_torax">
    <Info info="torax" />
  </div>

  <div class="input-group mb-3">
    <div class="input-group-prepend">
      <span class="input-group-text" id="basic-addon3">Cintura</span>
    </div>
    <input class="form-control form-control-lg" :class="[campoFormVazio && cintura == '' ? 'campo_vazio' : '' ]" :value="cintura" type="text" placeholder="Medidas da Cintura" @input="atualizar_cintura">
    <Info info="cintura" />
  </div>


  <div class="input-group mb-3">
    <div class="input-group-prepend">
      <span class="input-group-text" id="basic-addon3">Quadril</span>
    </div>
    <input class="form-control form-control-lg" :class="[campoFormVazio && quadril == '' ? 'campo_vazio' : '' ]" :value="quadril" type="text" placeholder="Medidas do Quadril" @input="atualizar_quadril">
    <Info info="quadril" />
  </div>

  <div class="input-group mb-3">
    <div class="input-group-prepend">
      <span class="input-group-text tooltip-dica" id="basic-addon3">Gancho</span>
    </div>
    <input class="form-control form-control-lg " :class="[campoFormVazio && gancho == '' ? 'campo_vazio' : '' ]" :value="gancho" type="text" placeholder="Medidas do Gancho" @input="atualizar_gancho">
    <Info info="gancho" />
  </div>

  <div class="d-flex" style="justify-content: flex-end;">
    <button class="btn btn-lg btn-primary mr" v-on:click="calcularTabela" :disabled="btnCalcular == 'CALCULADO'? true : false" v-html="btnCalcular" :class="btnCalcular == 'CALCULADO' ? 'btn-dark' : 'btn-orange'" ></button>
  </div>
</div>

<div class="container" style="margin-top:30px;" v-show="calculo">
  <h5 class="titulo">RESULTADO: </h5>
  <div class="row resultado">
    <div v-if="tem_alerta" class="col-md-6">
      <div >
        <!-- <h4>Alertas</h4> -->
        <p>ALERTAS:</p>
        <div v-show="resultado.obs.var_min_torax" class="alert alert-warning alertas" role="alert">
          Variação mínima do torax não corresponde ao limite definido!
        </div>
        <div v-show="resultado.obs.var_max_torax" class="alert alert-warning alertas" role="alert">
          Variação máxima do torax não corresponde ao limite definido!
        </div>
        <div v-show="resultado.obs.var_min_cintura" class="alert alert-warning alertas" role="alert">
          Variação mínima da cintura não corresponde ao limite definido!
        </div>
        <div v-show="resultado.obs.var_max_cintura" class="alert alert-warning alertas" role="alert">
          Variação máxima da cintura não corresponde ao limite definido!
        </div>
        <div v-show="resultado.obs.var_min_quadril" class="alert alert-warning alertas" role="alert">
          Variação mínima do quadril não corresponde ao limite definido!
        </div>
        <div v-show="resultado.obs.var_max_quadril" class="alert alert-warning alertas" role="alert">
          Variação máxima do quadril não corresponde ao limite definido!
        </div>
        <div v-show="resultado.obs.var_min_gancho" class="alert alert-warning alertas" role="alert">
          Variação mínima do gancho não corresponde ao limite definido!
        </div>
        <div v-show="resultado.obs.var_max_gancho" class="alert alert-warning alertas" role="alert">
          Variação máxima do gancho não corresponde ao limite definido!
        </div>
      </div>  
    </div>
    <div :class="tem_alerta ? 'col-md-6':'col-md-12 text-center'">
      <p>MELHOR RESULTADO DE MOLDE:</p>
      <h3 style="color: #e49142" v-html="tamanho"></h3>
    </div>
  </div>

</div>

<!-- comparativo -->
<div v-if="indexResultado" style="margin-top:30px;" class="container">
  <h5 class="titulo">COMPARATIVO MODELO X MOLDE </h5>
  <table class="table table-striped">
    <thead>
      <tr>
        <th>Referencia</th>
        <th>torax</th>
        <th>cintura</th>
        <th>quadril</th>
        <th>gancho</th>

      </tr>
    </thead>
    <tbody >
      <!-- <tr id="linha-{{index}}"> -->
        <tr>
          <td>Molde Ballare</td>
          <td>{{tabela[indexResultado].torax}}</td>
          <td>{{tabela[indexResultado].cintura}}</td>
          <td>{{tabela[indexResultado].quadril}}</td>
          <td>{{tabela[indexResultado].gancho}}</td>

        </tr>
        <tr>
          <td>Modelo</td>
          <td>{{$store.state.torax}}</td>
          <td>{{$store.state.cintura}}</td>
          <td>{{$store.state.quadril}}</td>
          <td>{{$store.state.gancho}}</td>
        </tr>
        <tr>
          <td>Diferença para o Molde</td>
          <td :class="ClasseDiferenca(tabela[indexResultado].torax,torax)">{{tabela[indexResultado].diferenca_torax}}</td>
          <td :class="ClasseDiferenca(tabela[indexResultado].cintura,cintura)">{{tabela[indexResultado].diferenca_cintura}}</td>
          <td :class="ClasseDiferenca(tabela[indexResultado].quadril,quadril)">{{tabela[indexResultado].diferenca_quadril}}</td>
          <td :class="ClasseDiferenca(tabela[indexResultado].gancho,gancho)">{{tabela[indexResultado].diferenca_gancho}}</td>
        </tr>

      </tbody>
    </table>


  </div>
  <!-- comparativo -->

<!-- <pre>
  {{tabela}}
</pre> -->



</div>

</template>


<script>

import Info from './Info'
import SVGMolde from './SVG'

export default {
  name: 'Formulario',
  components:{
    Info,
    SVGMolde
  },
  data () {
    return {
      // torax: 75,
      // cintura: 66,
      // quadril: 87,
      // gancho: 122,
      campoFormVazio: false,
      tem_alerta: false,
      alertas:[],
      tabela:[],
      resultado:{},
      pontos_molde:'',
      pontos_modelo:'',
      showmolde:false,
      indexResultado: null,
      calculo:null,
      tamanho: "",
      btnCalcular: "",
      valoresCalculados : {},
      modelo:{},
      molde:{}
    }
  },
  computed:{
    torax: function(){
      return this.$store.state.torax
    },
    cintura: function(){
      return this.$store.state.cintura
    },
    quadril: function(){
      return this.$store.state.quadril
    },
    gancho: function(){
      return this.$store.state.gancho
    },

  },
  created: function () {
    // console.log("CRIADO");
    // this.PontosModelo();
    this.calcularTabela();
    $('.tooltip-dica').tooltip()
  },
  methods:{
    atualizar_torax:function(e){
      this.$store.commit('ATUALIZAR_TORAX', e.target.value)
      if(this.valoresCalculados.torax != parseInt(e.target.value)){
        this.btnCalcular = "RECALCULAR"
      }else{
        this.btnCalcular = "CALCULADO"
      }
    },
    atualizar_cintura:function(e){
      this.$store.commit('ATUALIZAR_CINTURA', e.target.value)
      if(this.valoresCalculados.cintura !=  parseInt(e.target.value)){
        this.btnCalcular = "RECALCULAR"
      }else{
        this.btnCalcular = "CALCULADO"
      }
    },
    atualizar_quadril:function(e){
      this.$store.commit('ATUALIZAR_QUADRIL', e.target.value)
      if(this.valoresCalculados.quadril != parseInt(e.target.value)){
        this.btnCalcular = "RECALCULAR"
      }else{
        this.btnCalcular = "CALCULADO"
      }
    },
    atualizar_gancho:function(e){
      this.$store.commit('ATUALIZAR_GANCHO', e.target.value)

      if(this.valoresCalculados.gancho != parseInt(e.target.value)){
        this.btnCalcular = "RECALCULAR"
      }else{
        this.btnCalcular = "CALCULADO"
      }
    },
    calcularTabela: function(){
      let self = this

      if(self.torax == null || self.torax == "" || self.cintura == null || self.cintura == "" || self.quadril == null || self.quadril == "" || self.gancho == null || self.gancho == ""){
        self.campoFormVazio = true
        return 
      }else{
        self.campoFormVazio = false
      }

      let alertas = false
      let mQcorresp = []
      let indexMolde = null 
      let diferenca = null 
      let tabela = JSON.parse(JSON.stringify(TabelaMoldes))

      for(let i = 0; i<tabela.length; i+=1){
        tabela[i].diferenca_torax = Math.abs(tabela[i].torax - this.torax)
        tabela[i].diferenca_cintura = Math.abs(tabela[i].cintura - this.cintura)
        tabela[i].diferenca_quadril = Math.abs(tabela[i].quadril - this.quadril)
        tabela[i].diferenca_gancho = Math.abs(tabela[i].gancho - this.gancho)
        // tabela[i].diferenca_torax = this.torax - tabela[i].torax
        // tabela[i].diferenca_cintura = this.cintura - tabela[i].cintura
        // tabela[i].diferenca_quadril = this.quadril - tabela[i].quadril
        // tabela[i].diferenca_gancho = this.gancho - tabela[i].gancho

        tabela[i].soma_diferenca = tabela[i].diferenca_torax + tabela[i].diferenca_cintura + tabela[i].diferenca_quadril + tabela[i].diferenca_gancho

        if(i == 0){
          indexMolde = i
          diferenca = tabela[i].soma_diferenca
        }else{
          if(tabela[i].soma_diferenca < diferenca){
            // console.log("entra");
            // console.log(tabela[i].soma_diferenca);
            indexMolde = i,
            diferenca = tabela[i].soma_diferenca
          }

          // if((tabela[i].diferenca_torax <= tabela[i].variacao_minima_largura && tabela[i].diferenca_torax <= tabela[i].variacao_maxima_largura) && (tabela[i].diferenca_cintura <= tabela[i].variacao_minima_largura && tabela[i].diferenca_cintura <= tabela[i].variacao_maxima_largura) && (tabela[i].diferenca_quadril <= tabela[i].variacao_minima_largura && tabela[i].diferenca_quadril <= tabela[i].variacao_maxima_largura) && (tabela[i].diferenca_gancho <= tabela[i].variacao_minima_gancho && tabela[i].diferenca_gancho <= tabela[i].variacao_maxima_gancho)){
          //   mQcorresp.push(i)
          // }else{


            if(i == 5){
              console.log("index");
            }
            if(tabela[i].diferenca_torax > tabela[i].variacao_minima_largura){
              tabela[i].obs.var_min_torax  = true
            }else{
              tabela[i].obs.var_min_torax  = false
            }
            if(tabela[i].diferenca_torax > tabela[i].variacao_maxima_largura){
              tabela[i].obs.var_max_torax  = true
            }else{
              tabela[i].obs.var_max_torax  = false
            }
            if(tabela[i].diferenca_cintura > tabela[i].variacao_minima_largura){
              tabela[i].obs.var_min_cintura  = true
            }else{
              tabela[i].obs.var_min_cintura  = false
            }
            if(tabela[i].diferenca_cintura > tabela[i].variacao_maxima_largura ){
              tabela[i].obs.var_max_cintura = true
            }else{
              tabela[i].obs.var_max_cintura = false
            }
            if(tabela[i].diferenca_quadril > tabela[i].variacao_minima_largura ){
              tabela[i].obs.var_min_quadril  = true
            }else{
              tabela[i].obs.var_min_quadril  = false
            }
            if(tabela[i].diferenca_quadril > tabela[i].variacao_maxima_largura){
              tabela[i].obs.var_max_quadril  = true
            }else{
              tabela[i].obs.var_max_quadril  = false
            }

            if(tabela[i].diferenca_gancho > tabela[i].variacao_minima_gancho){
              tabela[i].obs.var_min_gancho = true
            }else{
              tabela[i].obs.var_min_gancho = false
            }
            if(tabela[i].diferenca_gancho > tabela[i].variacao_maxima_gancho){
              tabela[i].obs.var_max_gancho = true
            }else{
              tabela[i].obs.var_max_gancho = false
            }



          // }

        }

      }
      let msg = []
                  // Object.assign(msg,  this.tabela[indexMolde].obs)
                  // this.alertas = msg



                  if(tabela[indexMolde].obs.var_min_torax + tabela[indexMolde].obs.var_max_torax + tabela[indexMolde].obs.var_min_cintura + tabela[indexMolde].obs.var_max_cintura+ tabela[indexMolde].obs.var_min_quadril + tabela[indexMolde].obs.var_max_quadril + tabela[indexMolde].obs.var_min_gancho+ tabela[indexMolde].obs.var_max_gancho > 0){
                    alertas = true
                  }else{

                    alertas = false
                  }

                  this.modelo = {torax: this.torax, cintura: this.cintura, quadril: this.quadril, gancho: this.gancho}
                  this.molde = {torax: tabela[indexMolde].torax, cintura: tabela[indexMolde].cintura, quadril: tabela[indexMolde].quadril, gancho: tabela[indexMolde].gancho}
                  this.valoresCalculados = {torax: this.torax, cintura: this.cintura, quadril: this.quadril, gancho: this.gancho}
                  this.btnCalcular = "CALCULADO"
                  this.tem_alerta = alertas
                  this.calculo = true
                  this.tamanho = tabela[indexMolde].molde +" - "+tabela[indexMolde].tabela
                  this.resultado = tabela[indexMolde]

                  self.tabela = tabela
                  this.indexResultado = indexMolde
                  this.PontosModelo()
                  this.PontosMolde()



                },
                PontosModelo: function () {
                  var self = this
                  var asvg = 350
                  var lsvg = 350
                  var csvg = asvg/2
                  let pontos_torax = function(){
                    let torax = parseFloat(self.torax)

                    let x1 = (csvg - torax)
                    let x2 = (csvg + torax )
                    let y1 = ''
                    let y2 = ''
                    return {x1 , x2}

                  }
                  let pontos_cintura =  function(){
                    let y1 = ''
                    let y2 = ''
                    let cintura = parseFloat(self.cintura)

                    let x1 = (csvg - cintura)
                    let x2 = (csvg + cintura)
                    return {x1 , x2, y1, y2}

                  }
                  let pontos_quadril =  function(){
                    let quadril = parseFloat(self.quadril )

                    let x1 = (csvg - quadril)
                    let x2 = (csvg + quadril)
                    return {x1, x2}

                  }
                  let pontos_gancho =  function(){
                    let gancho = parseFloat(self.gancho)

                    let y1 = (csvg - gancho)
                    let y2 = (csvg + gancho)
                    return {y1 , y2}

                  }
      // 2500,1500 7500,1500 6178.95,4339.98 7500,7040.14 5000,8500 2500,7040.14 3821.05,4339.98
      this.pontos_modelo = pontos_torax().x1+','+pontos_gancho().y1+' '+pontos_torax().x2+','+pontos_gancho().y1+' '+pontos_cintura().x2+','+csvg+' '+pontos_quadril().x2+','+(pontos_gancho().y2 - csvg/5)+' '+csvg+','+pontos_gancho().y2+' '+pontos_quadril().x1+','+(pontos_gancho().y2 - csvg/5)+' '+pontos_cintura().x1+','+csvg
        // molde:(pontos_torax().x1+10)+','+(pontos_gancho().y1+3)+' '+(pontos_torax().x2-10)+','+(pontos_gancho().y1+3)+' '+pontos_cintura().x2+','+csvg+' '+(pontos_quadril().x2-2)+','+(pontos_gancho().y2 - csvg/5)+' '+csvg+','+(pontos_gancho().y2-3)+' '+(pontos_quadril().x1+2)+','+(pontos_gancho().y2 - csvg/5)+' '+pontos_cintura().x1+','+csvg
      },
      PontosMolde: function () {
        var Molde = this.tabela[this.indexResultado]
        var self = this
        var asvg = 350
        var lsvg = 350
        var csvg = asvg/2
        let pontos_torax = function(){
          let torax = parseFloat(Molde.torax)

          let x1 = (csvg - torax)
          let x2 = (csvg + torax )
          let y1 = ''
          let y2 = ''
          return {x1 , x2}

        }
        let pontos_cintura =  function(){
          let y1 = ''
          let y2 = ''
          let cintura = parseFloat(Molde.cintura)

          let x1 = (csvg - cintura)
          let x2 = (csvg + cintura)
          return {x1 , x2, y1, y2}

        }
        let pontos_quadril =  function(){
          let quadril = parseFloat(Molde.quadril )

          let x1 = (csvg - quadril)
          let x2 = (csvg + quadril)
          return {x1, x2}

        }
        let pontos_gancho =  function(){
          let gancho = parseFloat(Molde.gancho)

          let y1 = (csvg - gancho)
          let y2 = (csvg + gancho)
          return {y1 , y2}

        }
      // 2500,1500 7500,1500 6178.95,4339.98 7500,7040.14 5000,8500 2500,7040.14 3821.05,4339.98
      this.pontos_molde = pontos_torax().x1+','+pontos_gancho().y1+' '+pontos_torax().x2+','+pontos_gancho().y1+' '+pontos_cintura().x2+','+csvg+' '+pontos_quadril().x2+','+(pontos_gancho().y2 - csvg/5)+' '+csvg+','+pontos_gancho().y2+' '+pontos_quadril().x1+','+(pontos_gancho().y2 - csvg/5)+' '+pontos_cintura().x1+','+csvg
        // molde:(pontos_torax().x1+10)+','+(pontos_gancho().y1+3)+' '+(pontos_torax().x2-10)+','+(pontos_gancho().y1+3)+' '+pontos_cintura().x2+','+csvg+' '+(pontos_quadril().x2-2)+','+(pontos_gancho().y2 - csvg/5)+' '+csvg+','+(pontos_gancho().y2-3)+' '+(pontos_quadril().x1+2)+','+(pontos_gancho().y2 - csvg/5)+' '+pontos_cintura().x1+','+csvg


      },
      ClasseDiferenca: function(x, y){
        if(x == y ) return 'igual'
          if(x > y ) return 'numMaior'
            if(y > x ) return 'numMenor'

          },
      }
    }
    </script>


    <style scoped>
   
    .svgmodelo{
      position: absolute;
      top:0;
      left: 15px;
      height: 0;
      opacity: 0 !important ;
      transition: opacity 2s ease !important;
      /*margin-bottom: 10px;*/
    }
    .svgmodelo.active{
      opacity:1 !important;
    }
    .svg_desatualizado{
      color:#e59042;
      position: absolute;
      bottom: 50px;
      left: 30px;
    }
    .alertas{
      font-size: 0.8em;
      margin-bottom: 0.4rem;
      background-color: #f9e093;
      padding: 0.15rem 1.25rem;
      max-width: 450px;

    }

    .resultado{
      margin-top: 20px;
      padding:10px;
      background-color: #f2f2f2;
      border-radius:10px; 
    }
    .titulo{
      color:#bdb9b9;
    }

    .fade-enter-active, .fade-leave-active {
      transition: opacity .5s
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
      opacity: 0
    }

    .btn-orange{
      color: #fff;
      background-color: #e59042;
      border-color: #c58951;
    }


    .numMaior:before{content: "+"}
    .numMaior{color:#009fff; font-weight: bold}
    .numMenor:before{content: "-"}
    .numMenor{color:#c13644; font-weight: bold}

    </style>



// WEBPACK FOOTER //
// src/components/partes/Formulario.vue